import * as fromDatatype from '../datatype-library/index';

export interface bl_inv_stock_level_monitoring_event_inv_label_hdr_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    event_hdr_guid: fromDatatype.GuidDataFieldInterface;
    inv_label_hdr_guid: fromDatatype.GuidDataFieldInterface;
    inv_label_list_hdr_guid: fromDatatype.GuidDataFieldInterface;
    optimal_stock_value: fromDatatype.NumericDatatypeInterface;
    maximum_stock_value: fromDatatype.NumericDatatypeInterface;

    // standard fields
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_inv_stock_level_monitoring_event_inv_label_hdr_link_RowClass implements bl_inv_stock_level_monitoring_event_inv_label_hdr_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    event_hdr_guid: fromDatatype.GuidDataFieldInterface;
    inv_label_hdr_guid: fromDatatype.GuidDataFieldInterface;
    inv_label_list_hdr_guid: fromDatatype.GuidDataFieldInterface;
    optimal_stock_value: fromDatatype.NumericDatatypeInterface;
    maximum_stock_value: fromDatatype.NumericDatatypeInterface;

    // standard fields
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}
